import SecureResidenceSubFrame from './SecureResidenceSubFrame';
import { panelByFrameId } from '../../utils/secureResidenceFlow';

const panel = panelByFrameId('frame-29')!;

export default function Frame29() {
  return <SecureResidenceSubFrame panel={panel} />;
}
